import {Mapper} from '@s-ui/domain'

/**
 * @implements Mapper
 */
export class TrackingAuthenticationMapper extends Mapper {
  /**
   * @constructor
   * @param {Object} param
   * @param {Object} param.config
   * @param {Object} param.fromPageTrackingJsonToTrackingDataValueObjectMapper
   */
  constructor({config, fromPageTrackingJsonToTrackingDataValueObjectMapper}) {
    super()

    this._config = config
    this._fromPageTrackingJsonToTrackingDataValueObjectMapper = fromPageTrackingJsonToTrackingDataValueObjectMapper
  }

  /**
   * @param {Object} param
   * @param {String} param.page
   * @param {String} param.culture
   * @param {Object} param.data
   * @param {String} param.data.make
   * @param {String} param.data.model
   * @param {String} param.data.bodyType
   * @param {String} param.data.version
   * @param {Array} param.data.vehicles
   * @param {String} param.data.title
   * @param {Number} param.data.pageNumber
   * @param {Object} param.data.filters
   * @param {Number} param.data.searchResultsCount
   */

  _mapErrorCodesToPageError({errorCode, isSocial}) {
    const errorCodesMapping = {
      403042: 'password o email incorrecto',
      400003: 'email ya registrado',
      400009: 'password invalido',
      400027: 'condiciones no aceptadas'
    }

    const errorCodesMappingSocial = {
      403042: 'vincular cuenta password incorrecto',
      400027: 'finalize registration error'
    }

    const mappedErrors = isSocial ? errorCodesMappingSocial : errorCodesMapping

    const DEFAULT_ERROR = 'error desconocido'

    return mappedErrors[errorCode] || DEFAULT_ERROR
  }

  _mapHitInformation({page}) {
    const {HIT_INFORMATIONS} = this._config.get('tracking')

    const {GOOGLE_AUTHENTICATION, STANDARD_LOGIN} = HIT_INFORMATIONS
    const hitInformationMapping = {
      LOGIN_ERROR: STANDARD_LOGIN,
      LINK_ACCOUNT_ERROR: GOOGLE_AUTHENTICATION,
      COMPLETE_REGISTRATION_ERROR: GOOGLE_AUTHENTICATION
    }

    const DEFAULT_HIT_INFORMATION = STANDARD_LOGIN

    return hitInformationMapping[page] || DEFAULT_HIT_INFORMATION
  }

  _mapHitOrigin({page}) {
    const {HIT_ORIGINS} = this._config.get('tracking')

    const {DEFAULT_LOGIN, SOCIAL_LOGIN} = HIT_ORIGINS
    const hitInformationMapping = {
      LOGIN_ERROR: DEFAULT_LOGIN,
      REGISTER_VALIDATION_ERROR: DEFAULT_LOGIN,
      LINK_ACCOUNT_ERROR: SOCIAL_LOGIN,
      COMPLETE_REGISTRATION_ERROR: SOCIAL_LOGIN
    }

    const DEFAULT_HIT_INFORMATION = DEFAULT_LOGIN

    return hitInformationMapping[page] || DEFAULT_HIT_INFORMATION
  }

  map({page, culture, data}) {
    const {errorCode} = data

    const trackingData = {}

    const SOCIAL_PAGES = ['LINK_ACCOUNT_ERROR', 'COMPLETE_REGISTRATION_ERROR']

    const isSocial = SOCIAL_PAGES.some(socialPage => socialPage === page)

    switch (page) {
      case 'LOGIN_ERROR':
      case 'LINK_ACCOUNT_ERROR':
      case 'REGISTER_VALIDATION_ERROR':
      case 'COMPLETE_REGISTRATION_ERROR':
        if (errorCode) trackingData.page_error = this._mapErrorCodesToPageError({errorCode, isSocial})
        break
      default:
        throw new Error(`No tracking data defined for page ${page}`)
    }

    trackingData.hit_information = this._mapHitInformation({page})
    trackingData.hit_origin = this._mapHitOrigin({page})

    return this._fromPageTrackingJsonToTrackingDataValueObjectMapper
      .setParams({
        page,
        culture
      })
      .map(trackingData)
  }
}
